module.exports = __webpack_public_path__ + "img/bgc5.92b942ce.jpg";